import React, { useState } from "react";
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider, useLocation } from "react-router-dom";
import routes from "../../Utils/routes";
import AuthLayout from "../../Components/AuthLayout";
import AppLayout from "../../Components/AppLayout";
import { PrivateRoute, PublicRoute } from "../../Utils/helperFunctions";
import { Grid, Paper } from "@mui/material";

const MyProfile = React.lazy(() => import("../MyProfile"));
const PrivacyPolicy = React.lazy(() => import("../Auth/PrivacyPolicy"));
const FAQ = React.lazy(() => import("../Service/components/FAQ"));
const Signup = React.lazy(() => import("../Auth/SignUp/index"));
const VerifyOTP = React.lazy(() => import("../Auth/VerifyOtp/index"));
const EmailConformation = React.lazy(() => import("../Auth/ConfirmEmail/index"));
const Login = React.lazy(() => import("../Auth/Login/index"));
const ForgotPassword = React.lazy(() => import("../Auth/ForgotPassword/index"));
const ConfirmPassword = React.lazy(() => import("../Auth/ConfirmPassword/index"));
const Home = React.lazy(() => import("../Home/index"));
const Events = React.lazy(() => import("../Events/index"));
const Service = React.lazy(() => import("../Service/index"));
const TicketPreview = React.lazy(() => import("../Service/components/Ticket/TicketPreview"));
const Answers = React.lazy(() => import("../Service/components/Questions/Answers"));
const RequestService = React.lazy(() => import("../Service/components/Requests/RequestService"));
const ExamSchedule = React.lazy(() => import("../ExamSchedule"));
const GradeCard = React.lazy(() => import("../GradeCard"));
const GradeCardsDownload = React.lazy(() => import("../GradeCard/GradeCardsDownload"));
const MarksBreakdown = React.lazy(() => import("../GradeCard/MarksBreakdown"));
const Learn = React.lazy(() => import("../Learn"));
const CourseEnrollment = React.lazy(() => import("../CourseEnrollment"));
const FeePayment = React.lazy(() => import("../FeePayment"));
const Fees = React.lazy(() => import("../FeePayment"));
const Schedule = React.lazy(() => import("../Schedule"));
const Settings = React.lazy(() => import("../Profile"));
const Profile = React.lazy(() => import("../MyProfile"));
const Tickets = React.lazy(() => import("../Service/AllTickets"));
const FeedbackDashboard = React.lazy(() => import("../Feedback"));
const FeedbackDetails = React.lazy(() => import("../Feedback/feedbackDetails"));
const CoreElective = React.lazy(() => import("../CourseEnrollment/CoreElective"));
const EnrolledCourse = React.lazy(() => import("../CourseEnrollment/EnrolledCourse"));
const ProgramPathway = React.lazy(() => import("../ProgramPathway"));
const Announcements = React.lazy(() => import("../Announcements"));
const Exams = React.lazy(() => import("../Exams"));
const TakeExams = React.lazy(() => import("../TakeExams"));
const ThankYouPage = React.lazy(() => import("../ThankYouPage/thankyoupage"));

const NotFound: React.FunctionComponent = () => {
  return <h1>Not Found</h1>;
};

const EnrolledCourseWrapper = () => {
  const location = useLocation();
  const programEnrollmentId = location.state?.programEnrollmentId;
  if (!programEnrollmentId) {
    return <div>Program Enrollment ID is missing.</div>;
  }
  return <EnrolledCourse programEnrollmentId={programEnrollmentId} />;
};

const MainLayout: React.FunctionComponent = () => {
  const [trem, setState] = useState("")
  const tremData = (data: string) => {
    setState(data)
  }
  const getTrem = () => {
    return trem
  }
  const router = createBrowserRouter(
    createRoutesFromElements(
      <React.Fragment>
        {/* Initial Route */}
        <Route path="/" element={<Navigate to={routes.login} />} />
        <Route path="*" element={<NotFound />} />

        {/* Public Routes */}
        <Route
          path={routes.login}
          index
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          path={routes.privacyPolicy}
          index
          element={
            <PublicRoute>
              <PrivacyPolicy />
            </PublicRoute>
          }
        />

        <Route
          path={routes.otpverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <VerifyOTP />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.emailverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <EmailConformation />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.forgotPassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ForgotPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.signup}
          element={
            <PublicRoute>
              <AuthLayout>
                <Signup />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.changePassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ConfirmPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />

        {/* Private Routes */}
        <Route
          path={routes.home}
          element={
            <PrivateRoute>
              <AppLayout>
                <Home tremData={tremData} />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* <Route
          path={routes.myProfile}
          element={
            <PrivateRoute>
              <AppLayout>
                <Profile />
              </AppLayout>
            </PrivateRoute>
          }
        /> */}

        {/* My Profile */}
        {/* <Route
          path={routes.myProfile}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyProfile />
              </AppLayout>
            </PrivateRoute>
          }
        /> */}
        {/* Events */}
        <Route
          path={`events/*`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Events />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Service and Support */}
        <Route
          path={`${routes.service}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Service />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.serviceFAQ}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <FAQ />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.RequestService}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <RequestService />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.Answers}/:serviceId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Answers />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.TicketPreview}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <TicketPreview />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* old */}
        <Route
          path={`${routes.service}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Service />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.RequestService}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <RequestService />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.Answers}/:serviceId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Answers />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.allTickets}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Tickets />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.TicketPreview}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <TicketPreview />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.exams}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Exams />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.examSchedule}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <ExamSchedule />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.takeExams}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <TakeExams />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.gradeCard}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <GradeCard />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.gradeCardsDownload}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <GradeCardsDownload />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.marksBreakdown}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <MarksBreakdown />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.learn}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Learn />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.feedback}
          element={
            <PrivateRoute>
              <AppLayout>
                <FeedbackDashboard />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/feedback/:type"
          element={
            <PrivateRoute>
              <AppLayout>
                <FeedbackDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.courseEnrollment}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <CourseEnrollment />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.programPathway}
          element={
            <PrivateRoute>
              <AppLayout>
                <ProgramPathway />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.coreElective}
          element={
            <PrivateRoute>
              <AppLayout>
                <CoreElective />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.enrolledCourses}
          element={
            <PrivateRoute>
              <AppLayout>
                <EnrolledCourseWrapper />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.feePayment}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <FeePayment />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.fees}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Fees />
              </AppLayout>
            </PrivateRoute>
          }
        />
       <Route path={`${routes.thankYouPage}`} element={<ThankYouPage />} />
        <Route
          path={`${routes.schedule}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Schedule getTrem={getTrem} />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.settings}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Settings />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.announcements}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Announcements />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Grid system test */}
        <Route
          path={"/grid-test"}
          element={
            <section style={{ padding: "20px", height: "100vh" }}>
              <Grid container columnSpacing={4} height={"100%"}>
                <Grid item lg={2}>
                  <Paper sx={{ height: "100%" }}>nav</Paper>
                </Grid>
                <Grid item container lg={10} spacing={3}>
                  <Grid item sx={{ height: "12%" }} lg={9}>
                    <Paper sx={{ height: "100%" }}>title</Paper>
                  </Grid>
                  <Grid item sx={{ height: "12%" }} lg={3}>
                    <Paper sx={{ height: "100%" }}>actions</Paper>
                  </Grid>
                  <Grid item sx={{ height: "38%" }} lg={12}>
                    <Paper sx={{ height: "100%" }}>banner</Paper>
                  </Grid>
                  <Grid item sx={{ height: "50%" }} lg={6}>
                    <Paper sx={{ height: "100%" }}>card1</Paper>
                  </Grid>
                  <Grid item sx={{ height: "50%" }} lg={6}>
                    <Paper sx={{ height: "100%" }}>card2</Paper>
                  </Grid>
                </Grid>
              </Grid>
            </section>
          }
        />
      </React.Fragment>
    )
  );

  return <RouterProvider router={router} />;
};

export default MainLayout;